import { Link } from "react-router-dom";
import { useGarden } from "@/hooks/useGarden";

export function GardenHealthCard() {
  const { data, isLoading } = useGarden();

  if (isLoading) {
    return (
      <section
        data-testid="garden-health-card"
        data-state="loading"
        className="rounded-2xl p-4"
        style={{
          background: "#FFFFFF",
          border: "1px solid #EAE4DA",
          minHeight: "80px",
        }}
      >
        <div
          className="h-5 w-32 animate-pulse rounded"
          style={{ background: "#EAE4DA" }}
        />
        <div
          className="mt-3 h-4 w-44 animate-pulse rounded"
          style={{ background: "#EAE4DA" }}
        />
      </section>
    );
  }

  const beds = data?.beds ?? [];
  const totalSqft = beds.reduce(
    (sum, b) => sum + b.widthFt * b.lengthFt,
    0,
  );

  if (beds.length === 0) {
    return (
      <section
        data-testid="garden-health-card"
        data-state="empty"
        className="rounded-2xl p-4"
        style={{
          background: "#FFFFFF",
          border: "1px solid #EAE4DA",
          minHeight: "80px",
        }}
      >
        <h3
          className="font-display text-lg italic"
          style={{ color: "#8A4E9C" }}
        >
          Garden Health
        </h3>
        <p
          className="mt-1 text-sm"
          style={{ color: "#9A8A78" }}
        >
          Your garden is empty.{" "}
          <Link
            to="/app/garden"
            className="font-medium underline"
            style={{ color: "#8A4E9C" }}
          >
            Tap Garden to add your first bed.
          </Link>
        </p>
      </section>
    );
  }

  return (
    <section
      data-testid="garden-health-card"
      data-state="loaded"
      className="rounded-2xl p-4"
      style={{
        background: "#FFFFFF",
        border: "1px solid #EAE4DA",
        minHeight: "80px",
      }}
    >
      <h3
        className="font-display text-lg italic"
        style={{ color: "#8A4E9C" }}
      >
        Garden Health
      </h3>
      <p
        className="mt-1 text-sm"
        style={{ color: "#1A1620" }}
        data-testid="garden-health-stats"
      >
        {beds.length} {beds.length === 1 ? "bed" : "beds"} ·{" "}
        {Math.round(totalSqft)} sqft
      </p>
      <p
        className="mt-0.5 text-xs italic"
        style={{ color: "#9A8A78", opacity: 0.7 }}
      >
        Planted-square counts coming in Week 2.3
      </p>
    </section>
  );
}
